export async function ApiClient(
  endpoint: string,
  options: RequestInit = {}
): Promise<any> {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  if (!baseUrl) {
    throw new Error(
      "REACT_APP_BASE_URL is not set. Please configure the API base URL in your environment variables."
    );
  }

  const url = `${baseUrl}${endpoint}`;

  const defaultHeaders: Record<string, string> = {
    Accept: "application/json",
  };

  // ✅ Automatically handle Content-Type for FormData
  if (!(options.body instanceof FormData)) {
    defaultHeaders["Content-Type"] = "application/json";
  }

  // ✅ Attach Bearer Token (if available)
  if (!endpoint.includes("/login") && !endpoint.includes("/register")) {
    // Check both sessionStorage and localStorage for token
    let token: string | null = null;
    try {
      token = sessionStorage.getItem("token") || localStorage.getItem("token");
      console.log("Retrieved token from storage:", token);
    } catch (error) {
      console.warn("Could not access storage for token:", error);
    }

    if (token && token.trim() !== "") {
      defaultHeaders.Authorization = `Bearer ${token}`;
    }
  }

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
  };

  try {
    const response = await fetch(url, config);

    // Check if response is ok (status 200-299)
    if (!response.ok) {
      // Handle 401 Unauthorized - Token expired or invalid
      // if (
      //   response.status === 401 &&
      //   !endpoint.includes("/login") &&
      //   !endpoint.includes("/register")
      // ) {
      //   // Clear invalid token from both storages
      //   try {
      //     sessionStorage.removeItem("token");
      //     localStorage.removeItem("token");
      //   } catch (e) {
      //     console.warn("Could not clear token:", e);
      //   }

      //   // Clear Redux state if needed
      //   try {
      //     // Dispatch clearAdmin action if available
      //     if (window.dispatchEvent) {
      //       window.dispatchEvent(new Event("logout"));
      //     }
      //   } catch (e) {
      //     console.warn("Could not dispatch logout event:", e);
      //   }

      //   // Redirect to login if not already there
      //   if (window.location.pathname !== "/login") {
      //     const currentPath = window.location.pathname + window.location.search;
      //     // Use replace to avoid adding to history
      //     window.location.replace(
      //       `/login?redirect=${encodeURIComponent(currentPath)}`
      //     );
      //   }

      //   throw new Error("Your session has expired. Please log in again.");
      // }

      // Try to parse error response as JSON, fallback to text
      const contentType = response.headers.get("content-type");
      let errorMessage = `Request failed with status ${response.status}`;

      if (contentType && contentType.includes("application/json")) {
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (e) {
          // If JSON parsing fails, try text
          const textError = await response.text();
          errorMessage = textError || errorMessage;
        }
      } else {
        // If response is HTML or other format, get text
        try {
          await response.text(); // Consume the response body
          errorMessage = `Server error: ${response.status} - ${response.statusText}`;
        } catch (e) {
          errorMessage = `Request failed with status ${response.status}`;
        }
      }

      throw new Error(errorMessage);
    }

    // Check content type before parsing JSON
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      // If not JSON, return text or throw error
      const text = await response.text();
      throw new Error(
        `Expected JSON response but got ${
          contentType || "unknown content type"
        }. Response: ${text.substring(0, 100)}`
      );
    }
  } catch (error: any) {
    console.error("Fetch error:", error);

    // Handle network errors
    if (error.name === "TypeError" && error.message.includes("fetch")) {
      throw new Error(
        "Network error. Please check your internet connection and try again."
      );
    }

    // Handle AbortError (request cancelled)
    if (error.name === "AbortError") {
      throw new Error("Request was cancelled.");
    }

    // If it's already an Error object with a message, throw it as is
    if (error instanceof Error) {
      throw error;
    }

    // Otherwise, wrap it in an Error
    throw new Error(error?.message || "Network request failed");
  }
}
